import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";

import { useUpdateRouteMutation } from "../../../../../api/jeep-rally/routes/routes.hooks";
import { initialRouteForm, mapRouteToForm, validateRouteForm, buildRoutePayload } from "../utils/route.utils";
import RouteForm from "../_components/RouteForm";

const RouteUpdatePage = () => {
  const history = useHistory();
  const { id } = useParams();

  const locationState = history.location.state || {};
  const route = locationState.route || null;
  const eventId = locationState.eventId || null;

  const canManage = (() => {
    try {
      const user = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
      const role = String(user.role || user.roles || "").toLowerCase().trim();
      return role === "admin";
    } catch {
      return false;
    }
  })();

  const [form, setForm] = useState(initialRouteForm);
  const [imageFile, setImageFile] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});

  const {
    mutate: updateRoute,
    isLoading,
    isPending,
    error: updateError,
  } = useUpdateRouteMutation();

  const submitting = isLoading || isPending;

  useEffect(() => {
    if (!route) return;
    setForm(mapRouteToForm(route));
    setImageFile(null);
    setValidationErrors({});
  }, [route]);

  const updateField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setValidationErrors((prev) => ({ ...prev, [key]: undefined }));
  };

  const handleImageChange = (file) => {
    setImageFile(file);
    setValidationErrors((prev) => ({ ...prev, track_map_image: undefined }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!canManage || !id || !route) return;

    const nextErrors = validateRouteForm(form, { imageFile });
    setValidationErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    const payload = buildRoutePayload(form, { imageFile, isEdit: true });
    updateRoute(
      { routeId: id, payload, eventId: eventId || undefined },
      {
        onSuccess: () => history.push("/jeep-rally/routes"),
      }
    );
  };

  const goBack = () => history.push("/jeep-rally/routes");

  if (!route) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <Alert variant="danger" className="mb-0">
              Route not found. Please open it from the Routes list.
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to routes list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <h4 className="card-title mb-0">Update Route</h4>
          </div>
        </div>

        <div className="card-body">
          {!canManage && (
            <Alert variant="warning" className="mb-4">
              Admin access is required to update routes.
            </Alert>
          )}

          {updateError && (
            <Alert variant="danger" className="mb-4">
              {updateError?.response?.data?.message || "Failed to update route."}
            </Alert>
          )}

          <RouteForm
            form={form}
            validationErrors={validationErrors}
            submitting={submitting}
            submitLabel="Update Route"
            submittingLabel="Updating..."
            readOnly={!canManage}
            imageFile={imageFile}
            existingImage={route?.track_map_image}
            onSubmit={handleSubmit}
            onFieldChange={updateField}
            onImageChange={handleImageChange}
            onBack={goBack}
          />
        </div>
      </div>
    </div>
  );
};

export default RouteUpdatePage;

